import React from 'react';
import { useTranslation } from 'react-i18next';

const PriceList = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="py-2">
        <div className="container">
          <h2 className="center p-1">{t('Price List')}</h2>
          <div className="bottom-line"></div>

          <div className="row">
            <div className="col-lg-12">
              <article className="card">
                <div>
                  <h3 className="mb-1">{t('Sick Note Fee')}</h3>
                  <div className="bottom-line"></div>

                  <table className="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th scope="col">{t('Service')}</th>
                        <th scope="col">{t('Price')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{t('Valid B.C. Services Card (Care Card)')}</td>
                        <td>
                          <span className="important-text">$65</span> <span className="note">{t('including GST')}</span>
                        </td>
                      </tr>
                      <tr>
                        <td>{t('No valid B.C. Services Card (Care Card)')}</td>
                        <td>
                          <span className="important-text">$130</span> <span className="note">{t('including GST')}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <p className="mt-3">
                    <span className="note">{t('Note:')}</span> {t('Additional fees may apply for complex cases requiring extended consultation or additional documentation.')}
                  </p>
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PriceList;
